<template>
  <div class="invite-rule">
    <div class="title">{{ $t('title') }}</div>
    <div class="rule">
      <div class="rule-item" v-for="(i, index) in ruleList" :key="index">
        {{ i }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  i18n: {
    messages: {
      en: {
        title: 'Terms and Conditions',
      },
      id: {
        title: 'Syarat dan Ketentuan',
      },
    },
  },
  data() {
    const locale = this.$store.state.locale
    const ruleList = {
      en: [
        '1. Inviter need to be registered to join "Invite Friends" event.',
        '2. Every month for the first three new invited friends who complete onboarding process, you will get Rp 50.000 funding voucher. Reward only valid for first three people. Every new month you can find another three people.',
        '3. Voucher Rp 50.000 can be used if you fund at least Rp 100.000.',
        '4. The inviter can get 1% bonus for each funding of all the friends invited by him (valid for all funding (including vip and new user privilege) products, invalid for trial card and flexible funding). Bonus = Invited person\'s lending amount × 1% × lending period / 365. Bonus will be issued in cashback coupon within 3 working days after the invitee has successfully invested. All the friends you invited can generate funding bonuses for you within six months after registration, regardless of the number of people. If the invitee has multiple funding within six months, and the inviter will receive multiple bonuses.',
        '5. After the invitee complete onboarding process through the referal link, he can get the 1% interest bonus coupon, Rp 9.999 cashback.',
        '6. Example: B is the third friend invited by A this month. After B complete onboarding process and invest in 365 days products for Rp10.000, A can get Rp 50.000 + Rp100 = Rp50.100 bonus.',
        '7. After cashback coupons are used, it will be added to unused balance. All cashback vouchers are rounded to two decimal places based on the amount.',
        '8. If cheating is found, Kredit Pintar will not give the rewards.',
        '9. The final decision of this event belongs to Kredit Pintar.',
      ],
      id: [
        '1. Pengundang harus terdaftar untuk mengikuti acara "Undang Teman".',
        '2. Setiap bulan jika tiga teman pertama telah menyelesaikan proses verifikasi, Anda akan mendapatkan voucher pendanaan Rp 50.000. Hadiah hanya berlaku untuk 3 orang pertama. Setiap bulan baru Anda dapat mencari teman baru lagi.',
        '3. Voucher Rp 50.000 dapat digunakan jika Anda melakukan pendanaan minimal Rp 100.000.',
        '4. Pengundang dapat memperoleh 1% bonus untuk setiap pendanaan dari semua teman yang diundang olehnya (berlaku untuk semua produk pendanaan (termasuk vip dan hak pengguna baru), tidak valid untuk trial card dan pendanaan fleksibel). Bonus = Jumlah pendanaan × 1% × periode pendanaan / 365. Bonus akan dikeluarkan dalam bentuk cashback dalam waktu 3 hari kerja setelah pihak yang diundang telah berhasil mendanai. Semua teman yang Anda undang dapat menghasilkan bonus pendanaan untuk Anda dalam waktu enam bulan setelah pendaftaran, tidak ada batas maksimal orang. Jika orang yang diundang mendanai berulangkali dalam waktu enam bulan, dan pengundang akan menerima bonus berulangkali.',
        '5. Setelah teman yang diundang meyelesaikan proses verifikasi melalui link referral, dia bisa mendapatkan kupon bonus bunga 1% , cashback Rp 9.999.',
        '6. Contoh: B adalah teman ketiga yang diundang oleh A bulan ini. Setelah B menyelesaikan proses verifikasi dan mendanai produk 365 hari seharga Rp10.000, A bisa mendapat bonus Rp50.000 + Rp100 = Rp50.100.',
        '7. Setelah kupon cashback digunakan, itu akan ditambahkan ke sisa nominal. Semua voucher cashback dibulatkan menjadi dua desimal berdasarkan jumlah.',
        '8. Jika terjadi kecurangan, Kredit Pintar tidak akan membagikan hadiah.',
        '9. Keputusan akhir dari event ini dimiliki Kredit Pintar.',
      ],
    }
    return {
      ruleList: ruleList[locale],
    }
  },
}
</script>

<style scoped lang="stylus">
.invite-rule {
  color: #2C2E38;
  padding: 30px 20px 0;
  .title {
    font-size: 20px;
    text-align: center;
    font-weight: bold;
  }
  .rule {
    padding: 30px 0;
  }
  .rule-item {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 15px;
  }
}
</style>
